import styled from "styled-components";

export const CommonPageContainer = styled.div`
  width: 100%;
  height: 100%;
`